import UserList from "./UserList";

const User = (props) => {
  return <UserList {...props} />;
};

export default User;
